module.exports = __webpack_public_path__ + "static/media/21st_century_partner.536c4a6b.png";